<template>
    <div v-touch:swipe.right="prevQuestion" v-touch:swipe.left="nextQuestion">
      <div v-if="!getSurveyLoaded || !surveyStarted">
        <survey-start :survey="getSurveys[surveyIndex]"
                      :index="survey_id"
                      v-on:start-survey="surveyStarted=true">
        </survey-start>
      </div>
      <div v-else class="content">
        <transition :name="this.transitionDir" mode="out-in" appear>
          <div :key="getCurrentQuestionNum">
            <survey-confirm v-if="getCurrentQuestionNum >= (getCurrentSurvey.Questions.length)"
                            :survey_id="survey_id"
                            :index="survey_id"
                            v-on:back-survey="backToLastQuestion">
            </survey-confirm>
            <div v-else class="container-fluid container-fixed-lg">
              <div class="row">
                <div class="col-lg-6 m-b-10 d-flex">
                  <div :class="isCurrentQuestionInfo ? 'card text-center h-100 welcome' : 'card text-center h-100'">
                    <div class="card-header">
                      <div class="progress">
                        <div class="progress-bar progress-bar-complete" :style="`width: ${100 * (getCurrentQuestionNum) / (getCurrentSurvey.Questions.length)}% !important`"></div>
                      </div>
                      <h5 class="sectiontitle text-muted" :class="{'text-white':isCurrentQuestionInfo}">{{ getCurrentSurvey.Questions[getCurrentQuestionNum].Text }}</h5>
                    </div>

                    <div class="card-body">
                      <div class="questiondescription">
                        <p class="sectiondesc-2" :class="{'text-white':isCurrentQuestionInfo}">{{ getCurrentSurvey.Questions[getCurrentQuestionNum].Text2 }}</p>
                        <p class="sectiondesc-2" :class="{'text-white':isCurrentQuestionInfo}">{{ getCurrentSurvey.Questions[getCurrentQuestionNum].Text3 }}</p>
                      </div>

                      <component  :is="componentMap[getCurrentSurvey.Questions[getCurrentQuestionNum].QuestionTypeId]"
                                  :key="getCurrentQuestionNum"
                                  :question="getCurrentSurvey.Questions[getCurrentQuestionNum]"
                                  :auxParam="auxParam[getCurrentSurvey.Questions[getCurrentQuestionNum].QuestionTypeId]"/>

                      <div class="btn-group btn-group-justified w-100">
                        <button :class="(getCurrentQuestionNum <= 0) ? 'previousbutton text-24' : 'nextbutton bg-24 text-white'"
                                @click="prevQuestion"
                                :disabled="getCurrentQuestionNum <= 0">
                          {{ $t('survey_previous') }}
                        </button>
                        <button class="nextbutton " :class="{'text-white':!isCurrentQuestionInfo, 'bg-24':!isCurrentQuestionInfo, 'text-24':isCurrentQuestionInfo, 'bg-white':isCurrentQuestionInfo}"
                                @click="nextQuestion"
                                :disabled="isDisabledNext"
                        >
                          {{ $t('survey_next') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
</template>

<script>
  // import QuestionCheckbox from './types/Checkbox' // not used
  // import QuestionValue from './types/Value' // not used
  // import QuestionRadio from './types/Radio'
  import QuestionOptions from './types/Options'
  import QuestionText from './types/Text'
  import QuestionInfo from './types/Info'
  import QuestionNumeric from './types/Numeric'
  import QuestionPercentage from './types/Percentage'
  import QuestionDatetime from './types/Datetime'
  import QuestionStars from './types/Stars'
  import QuestionSmileys from './types/Smileys'
  import SurveyStart from '../surveys/SurveyStart'
  import SurveyConfirm from '../surveys/SurveyConfirm'
  import { mapGetters } from 'vuex'
  import { mapMutations } from 'vuex'
  import { mapActions } from 'vuex'

  export default {
    props: ['survey_id'],
    data () {
      return {
        questionNum: 0,
        transitionDir: 'slideleft',
        surveyStarted: false,
        componentMap: {
          '00000000-0000-0000-0000-000000000000': 'QuestionText',
          '00000000-0000-0000-0000-000000000001': 'QuestionOptions',
          '00000000-0000-0000-0000-000000000002': 'QuestionInfo',
          '00000000-0000-0000-0000-000000000010': 'QuestionNumeric',
          '00000000-0000-0000-0000-000000000011': 'QuestionNumeric',
          '00000000-0000-0000-0000-000000000012': 'QuestionNumeric',
          '00000000-0000-0000-0000-000000000020': 'QuestionPercentage',
          '00000000-0000-0000-0000-000000000021': 'QuestionDatetime',
          '00000000-0000-0000-0000-000000000022': 'QuestionDatetime',
          '00000000-0000-0000-0000-000000000023': 'QuestionDatetime',
          '00000000-0000-0000-0000-000000000030': 'QuestionStars',
          '00000000-0000-0000-0000-000000000031': 'QuestionSmileys',
        },
        auxParam: {
          '00000000-0000-0000-0000-000000000010': '1',
          '00000000-0000-0000-0000-000000000011': '0.1',
          '00000000-0000-0000-0000-000000000012': '0.01',
          '00000000-0000-0000-0000-000000000021': 'date',
          '00000000-0000-0000-0000-000000000022': 'time',
          '00000000-0000-0000-0000-000000000023': 'datetime',
        }
      }
    },
    components:   {SurveyStart, SurveyConfirm,
                  QuestionText, QuestionOptions, QuestionInfo, QuestionNumeric, QuestionPercentage, QuestionDatetime, QuestionStars, QuestionSmileys},
    computed: {
      ...mapGetters([
        'getSurveys',
        'getSurveyLoaded',
        'getCurrentSurvey',
        'getCurrentQuestionNum',
      ]),
      currentQuestion () {
        return this.getCurrentSurvey.Questions[this.getCurrentQuestionNum]
      },
      isCurrentQuestionInfo () {
                return this.currentQuestion.QuestionTypeId === '00000000-0000-0000-0000-000000000002'
      },
      isDisabledNext () {
        if (this.isCurrentQuestionInfo) return false
        return !this.currentQuestion.GivenAnswer
      },
      surveyIndex() {
        return this.getSurveys.findIndex((obj => obj.Id === this.survey_id))
      },
    },
    methods: {
      ...mapMutations([
        'SET_CURRENT_QUESTION_NUM',
      ]),
      ...mapActions([
        'loadCurrentSurvey',
        'saveSurveyAnswer',
      ]),
      saveAnswer() {
        this.saveSurveyAnswer(
          {
            sid: this.survey_id,
            questionId: this.getCurrentSurvey.Questions[this.getCurrentQuestionNum].Id,
            answer: this.getCurrentSurvey.Questions[this.getCurrentQuestionNum].GivenAnswer
          }
        )
      },
      backToLastQuestion() {
        this.SET_CURRENT_QUESTION_NUM(this.getCurrentQuestionNum - 1)
        this.transitionDir = 'slideright'
      },
      prevQuestion() {
        if (this.getCurrentQuestionNum > 0) {
          this.saveAnswer()
          this.SET_CURRENT_QUESTION_NUM(this.getCurrentQuestionNum - 1)
          this.transitionDir = 'slideright'
        }
      },
      nextQuestion() {
        if (!this.isDisabledNext && this.getCurrentQuestionNum < this.getCurrentSurvey.Questions.length) {
          this.saveAnswer()
          this.SET_CURRENT_QUESTION_NUM(this.getCurrentQuestionNum + 1)
          this.transitionDir = 'slideleft'
        }
      },
    },
    created() {
      this.loadCurrentSurvey(this.survey_id)
    },
    beforeDestroy() {
      if (this.getCurrentQuestionNum < this.getCurrentSurvey.Questions.length) {
        this.saveAnswer()
      }
    },
  }
</script>

<style scoped>
  .card-header {
    min-height: 48px !important;
    height: 100% !important;
    padding: 20px 20px 7px 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/surveys/SurveyPage.vue